import { graphql } from 'react-relay';
import { useEffect, useState } from 'react';
import type {
	useContentInfoContentOwnershipContentInfoQuery as useContentInfoContentOwnershipContentInfoQuery$data,
	useContentInfoContentOwnershipContentInfoQueryVariables as useContentInfoContentOwnershipContentInfoQuery$variables,
} from './__types__/useContentInfoContentOwnershipContentInfoQuery.ts';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
export const useContentInfo = ({ contentId }) => {
	const [contentTitle, setContentTitle] = useState<string>('');
	const [isArchived, setIsArchived] = useState<boolean>(false);
	const { data } = useQueryInterop<
		useContentInfoContentOwnershipContentInfoQuery$data,
		useContentInfoContentOwnershipContentInfoQuery$variables
	>(
		graphql`
			query useContentInfoContentOwnershipContentInfoQuery($contentId: ID!) {
				singleContent(id: $contentId) {
					id
					title
					status
				}
			}
		`,
		{
			variables: { contentId },
		},
	);

	useEffect(() => {
		const title = data?.singleContent?.title ?? '';
		const archived = data?.singleContent?.status === 'archived';
		setContentTitle(title);
		setIsArchived(archived);
	}, [data]);

	return { contentTitle, isArchived };
};
